export const clearWebSocketDisabledFlag = () => {
    localStorage.removeItem('websocket_disabled');
};

export const isWebSocketDisabled = () => {
    return localStorage.getItem('websocket_disabled') === 'true';
};

export const setWebSocketDisabled = (disabled: boolean) => {
    if (disabled) {
        localStorage.setItem('websocket_disabled', 'true');
    } else {
        localStorage.removeItem('websocket_disabled');
    }
};

export const forceEnableWebSocket = () => {
    localStorage.removeItem('websocket_disabled');
    window.dispatchEvent(new CustomEvent('websocketReconnect'));
}; 